import './CommerceOps.scss';
import { ReactElement, useCallback, useMemo } from 'react';
import { CommerceOpsTable } from './CommerceOpsTable';
import {
  AsinDimension,
  BUYBOX_WIN_PERCENTAGE_DIMENSION_CONFIG_MAP,
  BuyboxTabProps
} from './CommerceOpsUtils';

const Buybox = ({ data: { buyboxEntries }, downloadTable }: BuyboxTabProps): ReactElement => {
  const buyboxDataMap = useMemo(
    () => ({
      [AsinDimension.ASIN]: buyboxEntries
    }),
    [buyboxEntries]
  );
  const downloadBuyboxCsv = useCallback(
    () => downloadTable('buybox', buyboxDataMap),
    [buyboxDataMap, downloadTable]
  );

  return (
    <div className='commerce-ops-section fill-section'>
      <CommerceOpsTable
        topRowConfig={{ showTopRow: true, dropdownEnabled: false }}
        dimensionConfigMap={BUYBOX_WIN_PERCENTAGE_DIMENSION_CONFIG_MAP}
        dataMap={buyboxDataMap}
        onDownload={downloadBuyboxCsv}
        viewConfig={{ fillHeight: true }}
      />
    </div>
  );
};

export { Buybox };
